<app-dialog-banner text="Configure Dashboard" [dialogRef]="dialogRef"></app-dialog-banner>
<div class="reset-button">
    <button mat-raised-button color="accent" (click)="resetToDefault()">Reset to default widgets</button>
</div>

<div class="widget-picker-grid">
  <div id="chosenWidgets"
    cdkDropList 
    [cdkDropListData]="chosenWidgets" (cdkDropListDropped)="drop($any($event), 'chosen')" 
    [cdkDropListConnectedTo]="['availableWidgets']"
    class="column chosen">
    <h3  matTooltip="Drag drop to sort, or remove by dropping back into available widgets">Chosen Widgets</h3>
    @for (widget of chosenWidgets; track $index) {
      <!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
      <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->      
      <div cdkDrag class="widget-item"  (click)="selectForPreview(widget)">
            <div style="flex:1; margin-bottom:4px;">
            {{ getName(widget) }}
            </div>
      </div>
    }
  </div>
    <div class="transfer-icon-container">
        <mat-icon class="transfer-icon">swap_horiz</mat-icon>
    </div>  

  <div id="availableWidgets" 
  cdkDropList [cdkDropListData]="allWidgets" class="column available"
  (cdkDropListDropped)="drop($any($event), 'available')" 
  [cdkDropListConnectedTo]="['chosenWidgets']">
    <h3 matTooltip="Drag into position in chosen widgets to include on page">Available Widgets</h3>
    @for (widget of allWidgets; track $index) {
      <div cdkDrag class="widget-item" (click)="selectForPreview(widget)">
        {{widget.name}}
      </div>
    }
  </div>

  <!-- Preview -->
  <div class="column preview">
    <h3>Preview</h3>
    <!-- Placeholder content -->
    <div class="preview-box">
        @if (previewWidget) {
            <div style="display: block; height: 100%; width: 100%">
                <app-dashboard-widget
                [availCharts]="availableForPreview"
                [chosenWidget]="previewWidget">
                </app-dashboard-widget>
            </div>
        }
    </div>
  </div>
</div>
